import { Fragment, useEffect, useState } from "react";
import "./partyPopperBlast.css";

export const PartyPopperBlast = ({ trigger = true }) => {
  const [blasts, setBlasts] = useState([]);
  const [fallPieces, setFallPieces] = useState([]);

  useEffect(() => {
    if (!trigger) return;

    // Create multiple blast bursts over 3-4 seconds
    const createBlast = () => {
      const blastId = Date.now() + Math.random();
      setBlasts((prev) => [...prev, blastId]);

      // Add falling pieces on each blast
      addFallingPieces();

      // Remove blast after animation completes
      setTimeout(() => {
        setBlasts((prev) => prev.filter((id) => id !== blastId));
      }, 4000);
    };

    // Create falling pieces
    const addFallingPieces = () => {
      const pieces = Array.from({ length: 150 }, (_, i) => ({
        id: Date.now() + Math.random() + i,
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
        duration: Math.random() * 2 + 2.5,
      }));
      setFallPieces((prev) => [...prev, ...pieces]);

      // Remove pieces after they fall
      setTimeout(() => {
        setFallPieces((prev) => prev.slice(150));
      }, 4000);
    };

    // Initial blast
    createBlast();

    // Additional blasts for extended effect (every 0.3-0.5 seconds)
    const blastIntervals = [
      setTimeout(createBlast, 300),
      setTimeout(createBlast, 600),
      setTimeout(createBlast, 900),
      setTimeout(createBlast, 1200),
      setTimeout(createBlast, 1500),
      setTimeout(createBlast, 1800),
      setTimeout(createBlast, 2100),
      setTimeout(createBlast, 2400),
    ];

    return () => blastIntervals.forEach((interval) => clearTimeout(interval));
  }, [trigger]);

  // Generate confetti pieces for each burst
  const generateConfetti = () => {
    return Array.from({ length: 120 }, (_, i) => (
      <div
        key={i}
        className="blast-confetti"
        style={{
          "--angle": Math.random() * 360 + "deg",
          "--distance": Math.random() * 350 + 250 + "px",
          "--delay": Math.random() * 0.4 + "s",
          "--duration": Math.random() * 2 + 2.5 + "s",
        }}
      >
        <span className={`confetti-piece confetti-${i % 4}`} />
      </div>
    ));
  };

  return (
    <Fragment>
      {/* Popper Center Point */}
      <div className="popper-center">
        <div className="popper-glow" />
      </div>

      {/* Blast Bursts Container */}
      <div className="party-blast-container">
        {blasts.map((blastId, index) => (
          <div key={blastId} className="blast-burst" style={{ "--burst-delay": index * 0.2 + "s" }}>
            {generateConfetti()}
          </div>
        ))}
      </div>

      {/* Heavy Fall Rain Effect Container */}
      <div className="confetti-fall-heavy-container">
        {fallPieces.map((piece) => (
          <div
            key={piece.id}
            className="heavy-fall-piece"
            style={{
              "--left": piece.left + "%",
              "--delay": piece.delay + "s",
              "--duration": piece.duration + "s",
            }}
          >
            <span className={`fall-piece-icon fall-${piece.id % 6}`} />
          </div>
        ))}
      </div>

      {/* Rain Effect Container */}
      <div className="confetti-rain-container">
        {Array.from({ length: 200 }, (_, i) => (
          <div
            key={`rain-${i}`}
            className="rain-confetti"
            style={{
              "--left": Math.random() * 100 + "%",
              "--delay": Math.random() * 3 + "s",
              "--duration": Math.random() * 2 + 3.5 + "s",
            }}
          >
            <span className={`rain-piece rain-${i % 5}`} />
          </div>
        ))}
      </div>

      {/* Particle Emitter System */}
      <div className="particle-system">
        {Array.from({ length: 60 }, (_, i) => (
          <div
            key={`particle-${i}`}
            className="flying-particle"
            style={{
              "--px-angle": Math.random() * 360 + "deg",
              "--px-distance": Math.random() * 300 + 200 + "px",
              "--px-delay": Math.random() * 2 + "s",
            }}
          >
            <i className="particle-icon">✨</i>
          </div>
        ))}
      </div>

      {/* Ribbon Streamers */}
      <div className="ribbon-container">
        {Array.from({ length: 12 }, (_, i) => (
          <div key={`ribbon-${i}`} className={`ribbon ribbon-${i}`} />
        ))}
      </div>
    </Fragment>
  );
};
